import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

Vue.use(Vuex)

// https://webpack.js.org/guides/dependency-management/#requirecontext
// require.context检索目录中的文件获取到所以文件
const modulesFiles = require.context('./modules', true, /\.js$/)
    // you do not need `import app from './modules/app'`
    // it will auto require all vuex module from modules file
    //用于组件引入多个文件  循环文件
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    // modules文件名
    // modulePathwe 文件内容拼接成对象
    // set './app.js' => 'app'
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
    const value = modulesFiles(modulePath)
    modules[moduleName] = value.default
    return modules
}, {})
const store = new Vuex.Store({
    modules,
    getters
})

export default store


// WEBPACK FOOTER //
// ./src/vuex/store.js